import mapboxgl from 'mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1Ijoicm9iYWFuaGFuZSIsImEiOiJjbDdhaTN1cGswMmZxM29sOTQwdHZ2cDg5In0.0-ktBzKuK32GavIy5stvzw';
mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;

// Mapbox draw
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
